import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OrderLine, OrderType, PartType } from './model/entity-model';
import _ from 'lodash';

export function onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
        {
            location: 'before',
            template: 'toolbarButtons',
        },
        {
            template: 'toolbarText',
            location: 'after',
        }
    );

    // Add clear filters button if filter row is enabled
    if (e.component.option('filterRow.visible')) {
        e.toolbarOptions.items.unshift({
            widget: 'dxButton',
            options: {
                icon: 'revert',
                elementAttr: { title: 'Clear Filters' },
                onClick: () => {
                    e.component.clearFilter();
                },
            },
            location: 'after',
        });
    }

    if (!e.component.option('stateStoring.enabled')) return;
    e.toolbarOptions.items.unshift({
        widget: 'dxButton',
        options: {
            icon: 'refresh',
            elementAttr: { title: 'Reset Grid Layout' },
            onClick: () => {
                e.component.state({});
            },
        },
        location: 'after',
    });
}

export class Utility {
    static ImageFileTypes = ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'svg', 'ico', 'tiff', 'tif', 'heic', 'heif', 'avif', 'webp'];
    static SalesTaxRate = 0.06;

    static isImage(fileName: string) {
        if (!fileName || !fileName.includes('.')) return false;

        const extension = fileName.split('.').pop();
        return Utility.ImageFileTypes.includes(extension);
    }

    static round(value: number, decimalPlaces: number = 0) {
        // negative numbers are rounded towards zero, which is wrong. To fix, convert value to positive, round, then convert back to negative
        return (Math.sign(value) * Math.round(Math.abs(value) * Math.pow(10, decimalPlaces))) / Math.pow(10, decimalPlaces);
    }

    static checkRowDoubleClick(e): boolean {
        const component: any = e.component;

        const initialClick = () => {
            component.clickCount = 1;
            component.clickKey = e.key;
            component.clickDate = new Date();
            return false;
        };

        const doubleClick = () => {
            component.clickCount = 0;
            component.clickKey = 0;
            component.clickDate = null;
            return true;
        };

        if (!component.clickCount || component.clickCount !== 1 || component.clickKey !== e.key) {
            return initialClick();
        } else if (component.clickKey === e.key) {
            const now: any = new Date();
            if (now - component.clickDate <= 300) return doubleClick();
            else return initialClick();
        }
    }

    static localToUtc(datetime: Date) {
        if (!datetime) return datetime;

        return moment(datetime).subtract(moment(datetime).utcOffset(), 'minutes').toDate();
    }

    static utcToLocal(datetime: Date) {
        if (!datetime) return datetime;
        else {
            return moment(datetime).add(moment(datetime).utcOffset(), 'minutes').toDate();
        }
    }

    static isAlphaNumeric(value) {
        // regex for alphanumeric only
        const re = /^[a-z0-9]+$/i;
        return !value || re.test(value);
    }

    static convertToAlphaNumeric(value: string): string {
        if (!value) return value;
        // regex for alphanumeric only
        const re = /[^a-z0-9]/gi;
        return value.replace(re, '');
    }

    static validateEmailAddresses(emails: string) {
        // regex that checks for comma separated emails. It does not allow for empty strings.
        const re = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g;
        return re.test(emails);
    }

    static calcLineTax(line: any, partTypes: any, orderType: OrderType) {
        let tax = 0;

        if (orderType.taxable) {
            const nonTaxable = _.some(partTypes, (x) => {
                return x.partTypeId === PartType.Types.NonTaxable;
            });
            if (!nonTaxable) tax = this.round(line.quantity * line.price * this.SalesTaxRate, 2);
            else tax = 0;
        } else tax = 0;
        return tax;
    }

    static setMinLine(lines: any[]): number {
        let minId = (_.minBy(lines, 'id') as any).id;
        if (minId < 0) minId--;
        else minId = -1;
        return minId;
    }

    static generateUUID(): string {
        // Fallback UUID generator for browsers that don't support crypto.randomUUID()
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }

        // Fallback implementation
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
